import { useMutation } from "@shared/lib/hooks";
import { ORGANISATION_LIST_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export default function useAddUsersToOrganisation() {
  const { mutate, isLoading, isSuccess, error } = useMutation({
    mutationFn: (params: {
      userId: string;
      brandOrganisationId: string;
      brandIds: string[];
    }) =>
      OrganisationService.addUserToOrganisation(
        params.userId,
        params.brandOrganisationId,
        params.brandIds
      ),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, _, { brandOrganisationId }) => {
      c.invalidateQueries({
        queryKey: [...ORGANISATION_LIST_QUERY_KEY, brandOrganisationId],
      });
    },
  });

  return {
    addUsersToOrganisation: mutate,
    isLoading,
    isSuccess,
    error,
  };
}
